import React from 'react'
import defaultMetaTags from '../components/hocs/defaultMetaTags'
import getRoutes from '../routes'
import scrollTopAfterNavigation from './hooks/scrollTopAfterNavigation'

export function App() {
  scrollTopAfterNavigation()
  return <div className='container-fluid'>{getRoutes()}</div>
}

export default defaultMetaTags(App)
